import { Box, Button, ButtonProps } from '@theme-ui/components'
import React, { ReactNode, useState } from 'react'
import { Modal } from './Modal/Modal'

interface ConfirmButtonProps {
  text?: ReactNode
  header?: ReactNode
  positiveText?: ReactNode
  negativeText?: ReactNode
  onConfirm?(): void
  disabled?: boolean
  buttonProps?: ButtonProps
}

export default function ConfirmButton({
  text,
  header,
  negativeText = 'Tidak',
  positiveText = 'Ya',
  onConfirm,
  disabled,
  buttonProps,
}: ConfirmButtonProps) {
  const [isOpen, setIsOpen] = useState(false)

  function handleConfirm() {
    onConfirm?.()
    setIsOpen(false)
  }

  return (
    <>
      <Button
        {...buttonProps}
        onClick={() => setIsOpen(true)}
        disabled={disabled}
      >
        {text}
      </Button>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        header={header}
      >
        <Box sx={{ textAlign: 'right' }}>
          <Button
            type="button"
            onClick={() => setIsOpen(false)}
            variant="outline"
            mr="3"
          >
            {negativeText}
          </Button>
          <Button type="button" onClick={handleConfirm} px="4">
            {positiveText}
          </Button>
        </Box>
      </Modal>
    </>
  )
}
